import { useMyTranslations } from '@hooks/useMyTranslations';
import { UseValidationTransFields } from './types';

export const DEFAULT_NAME_MIN_LENGTH = 2;

export const useValidation = () => {
  const { t } = useMyTranslations<UseValidationTransFields>('useValidation');

  const getMinLengthRule = (count: number) => ({
    value: count,
    message: t('minLength', { count }),
  });

  const getMaxLengthRule = (count: number) => ({
    value: count,
    message: t('maxLength', { count }),
  });

  const getErrorMessageByType = (type?: string, message?: string): string => {
    if (!type) return '';

    switch (type) {
      case 'required':
        return message || t('required');
      case 'minLength':
        return message || t('minLength');
      case 'maxLength':
        return message || t('maxLength');
      default:
        return message || '';
    }
  };

  return { getMinLengthRule, getMaxLengthRule, getErrorMessageByType };
};
